import toast from "react-hot-toast";
import ToastSuccessIcon from "../../assets/svg/toast-success-icon";
import CrossIcon from "../../assets/svg/cross-icon";
import AlertIcon from "../../assets/svg/alert-icon";
import InfoBtnIcon from "../../assets/svg/info-btn-icon";

const renderCurrentToast = (type: string) => {
  switch (type) {
    case "success":
      return {
        icon: <ToastSuccessIcon className="w-[18px] h-[18px]" />,
        bgColor: "bg-toast-success dark:bg-toast-success-dk",
        progressColor: "bg-verba-messenger dark:bg-verba-messenger-dk",
      };
    case "warning":
      return {
        icon: (
          <AlertIcon className="w-[18px] h-[18px] text-verba-mail dark:text-verba-mail-dk" />
        ),
        bgColor: "bg-toast-warning dark:bg-toast-warning-dk",
        progressColor: "bg-verba-mail dark:bg-verba-mail-dk",
      };
    case "error":
      return {
        icon: (
          <CrossIcon className="w-[18px] h-[18px] text-verba-red-alert dark:text-verba-red-alert-dk" />
        ),
        bgColor: "bg-toast-error dark:bg-toast-error-dk",
        progressColor: "bg-verba-red-alert dark:bg-verba-red-alert-dk",
      };
    case "info":
      return {
        icon: (
          <InfoBtnIcon className="w-[24px] h-[24px] text-verba-blue dark:text-verba-blue-dk" />
        ),
        bgColor: "bg-toast-information dark:bg-toast-information-dk",
        progressColor: "bg-verba-blue dark:bg-verba-blue-dk",
      };
    default:
      return {
        icon: <ToastSuccessIcon className="w-[18px] h-[18px]" />,
        bgColor: "bg-toast-success dark:bg-toast-success-dk",
        progressColor: "bg-verba-messenger dark:bg-verba-messenger-dk",
      };
  }
};

let activeDismissTimeoutId: ReturnType<typeof setTimeout> | null = null;

export const customToast = (
  toastMessage: string,
  type: "success" | "warning" | "error" | "info",
  duration: number = 3000,
  toastSubMessage?: string,
  position: "bottom-left" | "bottom-right" = "bottom-right"
) => {
  if (activeDismissTimeoutId) {
    clearTimeout(activeDismissTimeoutId);
    activeDismissTimeoutId = null;
  }
  toast.dismiss("custom-toast");

  const { icon, bgColor, progressColor } = renderCurrentToast(type);

  const toastInstance = toast.custom(
    (t) => {
      return (
        <div
          className={`${
            t.visible ? "animate-enter" : "animate-leave"
          } ${bgColor} rounded-[8px] p-[12px] shadow-toast relative overflow-hidden`}
        >
          <div className="flex items-center gap-[8px]">
            <div className="flex items-center gap-[8px]">
              {icon}
              <div className="flex flex-col gap-[2px] min-w-[250px] max-w-[250px]">
                {toastMessage && (
                  <p className="text-fixed-white dark:text-fixed-white-dk text-md font-medium break-words">
                    {toastMessage}
                  </p>
                )}
                {toastSubMessage && (
                  <p className="text-xs text-gray-100 dark:text-gray-100 break-words">
                    {toastSubMessage}
                  </p>
                )}
              </div>
            </div>
            <div className="flex items-center justify-center">
              <button onClick={() => toast.remove(t.id)}>
                <CrossIcon className="w-[20px] h-[20px] text-black/15 dark:text-black/15" />
              </button>
            </div>
          </div>

          <div className="absolute bottom-0 left-0 w-full h-[2px] bg-transparent">
            <div
              className={`h-full ${progressColor} animate-progress`}
              style={{
                width: "100%",
                animationDuration: `${duration}ms`,
              }}
            />
          </div>
        </div>
      );
    },
    {
      id: "custom-toast",
      duration: Infinity,
      position: position,
    }
  );

  activeDismissTimeoutId = setTimeout(() => {
    toast.remove("custom-toast");
    activeDismissTimeoutId = null;
  }, duration);

  return toastInstance;
};
